import { IDeviceMap } from "@types"
import { protectedApi } from "store/Api"


interface DevicePayload {
    deviceId: number[]
}

const devicesMap = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        deviceMap: builder.mutation<IDeviceMap[], DevicePayload>({
            query: (data) => {
                return {
                    method: "GET",
                    url: `devices/map?deviceId=[${data.deviceId}]`,
                }
            },
        }),
    }),
})

export const { useDeviceMapMutation } = devicesMap
